import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("pt");
  useEffect(() => {
    document.documentElement.lang = lang === "pt" ? "pt-BR" : "en";
  }, [lang]);
  return (
    <LangContext.Provider value={{ lang, setLang, t: translations[lang] }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);

export const translations = {
  pt: {
    navLinks: [
      ["Início", "inicio"],
      ["Quem Sou", "quem-sou"],
      ["Consulta Espiritual", "consulta"],
      ["Trabalhos", "trabalhos"],
      ["Pactuações", "pactuacoes"],
      ["Internacional", "internacional"],
      ["Aviso", "aviso"],
      ["Contato", "contato"],
    ],
    navCta: "Falar no WhatsApp",
    hero: {
      overline: "Alta Magia • Goétia Luciferiana • Consultoria Espiritual",
      title1: "MESTRE JONAS",
      title2: "BARCELLOS",
      tagline: "Atendimento no Brasil, em Portugal e internacional.",
      text: "Consultas oraculares e trabalhos espirituais personalizados, realizados com seriedade, discrição e sigilo absoluto.",
      cta1: "Falar com Mestre Jonas",
      cta2: "Conhecer os Trabalhos",
      note: "Todos os trabalhos iniciam-se por consulta espiritual.",
    },
    highlights: [
      { title: "Sigilo Absoluto", text: "Atendimento discreto e reservado." },
      { title: "Atendimento Personalizado", text: "Cada consulta e trabalho é direcionado de acordo com a situação apresentada pelo consulente." },
      { title: "Brasil • Portugal • Internacional", text: "Atendimento online para clientes no Brasil, Portugal e outros países." },
    ],
    marquee: ["Sigilo Absoluto", "Alta Magia", "Goétia Luciferiana", "Consultoria Espiritual", "Tradição", "Discrição", "Brasil • Portugal • Internacional"],
    about: {
      overline: "Quem Sou",
      title: "QUEM É MESTRE JONAS BARCELLOS",
      paragraphs: [
        "Mestre Jonas Barcellos atua no campo da Alta Magia, Goétia Luciferiana e consultoria espiritual, oferecendo consultas oraculares e trabalhos espirituais personalizados.",
        "Seu trabalho é direcionado a pessoas que procuram orientação espiritual, compreensão de situações pessoais e realização de práticas ritualísticas dentro de uma abordagem séria, reservada e individualizada.",
        "Cada atendimento é realizado com discrição, respeito à privacidade e atenção à situação apresentada pelo consulente.",
      ],
      cta: "Agendar uma Consulta",
      waMessage: "Olá, Mestre Jonas. Gostaria de agendar uma consulta espiritual.",
    },
    consulta: {
      overline: "Consulta Espiritual e Oracular",
      title1: "CONSULTA ESPIRITUAL POR",
      title2: "ORÁCULOS E TARÔ",
      intro1: "A Consulta Espiritual e Oracular é o primeiro e mais importante passo antes de qualquer trabalho espiritual. Por meio do Tarô e de oráculos espirituais, é possível acessar informações sobre o passado, o presente e as tendências futuras, trazendo clareza, orientação e direcionamento seguro.",
      intro2: "Todas as consultas são realizadas com seriedade, ética espiritual, sigilo absoluto e interpretação profunda, respeitando o livre-arbítrio do consulente.",
      ctaHero: "Agendar Consulta Espiritual",
      analysisOverline: "O Que Pode Ser Analisado",
      analysisTitle: "NA CONSULTA ORACULAR",
      analysis: [
        {
          id: "passado",
          title: "Passado",
          items: ["Situações espirituais que influenciam o presente", "Bloqueios energéticos antigos", "Vínculos espirituais formados no passado", "Origem de dificuldades recorrentes"],
        },
        {
          id: "presente",
          title: "Presente",
          items: ["Situação atual energética e espiritual", "Caminhos abertos e fechados no momento", "Influências espirituais ativas", "Pessoas e energias ao redor do consulente", "Possíveis interferências espirituais"],
        },
        {
          id: "futuro",
          title: "Futuro (Tendências)",
          items: ["Tendências futuras dos caminhos", "Possibilidades de evolução ou alerta", "O que pode se manifestar caso o caminho atual continue", "O que pode ser ajustado para melhores resultados"],
        },
      ],
      analysisNoteLabel: "Importante:",
      analysisNote: "o oráculo mostra tendências, não imposições. O futuro pode ser ajustado com escolhas conscientes.",
      questionsOverline: "Tipos de Perguntas",
      questionsTitle: "QUE PODEM SER FEITAS NA CONSULTA",
      questions: [
        {
          id: "financeira",
          title: "Vida Financeira e Prosperidade",
          items: ["Caminhos financeiros estão abertos?", "Há bloqueios espirituais na prosperidade?", "Qual a melhor direção para crescimento material?", "É indicado algum trabalho espiritual para prosperidade?"],
        },
        {
          id: "profissional",
          title: "Trabalho e Vida Profissional",
          items: ["Evolução profissional", "Mudança de emprego ou carreira", "Reconhecimento e crescimento", "Negócios próprios e oportunidades", "Obstáculos ocultos no ambiente profissional"],
        },
        {
          id: "amor",
          title: "Amor e Relacionamentos",
          items: ["Situação energética do relacionamento", "Sentimentos envolvidos", "Possibilidade de reconciliação", "Caminhos afetivos futuros", "Influências externas ou espirituais na relação"],
        },
        {
          id: "espiritualidade",
          title: "Espiritualidade e Energia Pessoal",
          items: ["Estado espiritual atual", "Proteção espiritual", "Presença de cargas negativas", "Necessidade de limpeza espiritual", "Influências espirituais ao redor"],
        },
        {
          id: "ataques",
          title: "Ataques, Inveja e Bloqueios",
          items: ["Existe inveja ou energia negativa direcionada?", "Há interferência espiritual externa?", "O que está bloqueando caminhos?", "Necessidade de proteção ou descarrego"],
        },
        {
          id: "pactos",
          title: "Pactos, Acordos e Trabalhos",
          items: ["Se é indicado ou não realizar trabalhos espirituais", "Qual tipo de trabalho é mais adequado", "Se pactos ou acordos espirituais são aconselháveis", "Qual entidade espiritual rege o caminho do consulente"],
        },
      ],
      howTitle: "COMO FUNCIONA A CONSULTA",
      how: [
        { label: "Atendimento", value: "Individual" },
        { label: "Modalidade", value: "À distância (online)" },
        { label: "Interpretação", value: "Clara e detalhada" },
        { label: "Sigilo", value: "Total sigilo e respeito" },
      ],
      warningTitle: "Aviso Importante",
      warning: "As consultas espirituais e oraculares têm caráter orientativo e espiritual. Não substituem tratamentos médicos, psicológicos ou decisões jurídicas.",
      finalTitle: "AGENDE SUA CONSULTA ESPIRITUAL",
      finalText: "Entre em contato pelo WhatsApp para agendar sua consulta com sigilo absoluto e atendimento personalizado.",
      cta: "Agendar Consulta Espiritual via WhatsApp",
      waMessage: "Olá, Mestre Jonas. Gostaria de agendar uma consulta espiritual.",
    },
    trabalhos: {
      overline: "Trabalhos Espirituais",
      title: "TRABALHOS ESPIRITUAIS PERSONALIZADOS",
      intro: "Realização de trabalhos e rituais espirituais personalizados de acordo com a necessidade apresentada pelo consulente.",
      categories: [
        {
          id: "prosperity",
          title: "Prosperidade e Finanças",
          items: ["Abertura de caminhos financeiros", "Rituais de prosperidade", "Rituais de abundância", "Desbloqueio de caminhos", "Trabalhos personalizados relacionados à vida financeira"],
        },
        {
          id: "love",
          title: "Amor e Relacionamentos",
          items: ["Ritual de abertura de caminhos amorosos", "Ritual de atração amorosa", "Ritual de amarração amorosa", "Ritual de adoçamento amoroso", "Ritual de reconciliação de casal", "Ritual de harmonização de casal", "Trabalhos personalizados relacionados ao amor"],
        },
        {
          id: "cleansing",
          title: "Limpeza e Desligamento",
          items: ["Limpeza espiritual profunda", "Quebra de demanda", "Afastamento espiritual", "Desligamento de laços", "Cortes energéticos", "Trabalhos de limpeza espiritual"],
        },
        {
          id: "protection",
          title: "Proteção",
          items: ["Proteção espiritual", "Proteção Luciferiana", "Fortalecimento espiritual", "Trabalhos de defesa espiritual"],
        },
        {
          id: "power",
          title: "Poder Pessoal",
          items: ["Ritual de empoderamento", "Ritual de beleza", "Fortalecimento pessoal", "Trabalhos de desenvolvimento e fortalecimento espiritual"],
        },
        {
          id: "justice",
          title: "Justiça, Verdade e Revelação",
          items: ["Ritual de justiça espiritual", "Trabalhos relacionados à justiça", "Ritual de verdade e revelação", "Outros trabalhos personalizados"],
        },
      ],
      note: "A indicação de cada trabalho é realizada individualmente, considerando a situação apresentada durante o atendimento.",
      warning: {
        title: "Aviso Importante",
        items: [
          "Todos os trabalhos espirituais são realizados com responsabilidade e orientação oracular.",
          "Os resultados variam conforme a pessoa, o momento e o merecimento espiritual.",
          "Não substituem tratamentos médicos, psicológicos ou decisões jurídicas.",
        ],
      },
      cta: "Falar Sobre Meu Caso",
      waMessage: "Olá, Mestre Jonas. Gostaria de falar sobre meu caso.",
    },
    pactuacoes: {
      overline: "Acordos Conscientes",
      title1: "PACTUAÇÕES E ACORDOS",
      title2: "ESPIRITUAIS",
      intro1: "As pactuações e acordos espirituais são realizados exclusivamente após consulta oracular profunda, com total clareza, responsabilidade espiritual e alinhamento consciente entre o consulente e a entidade indicada.",
      intro2: "São trabalhos voltados a prosperidade, crescimento profissional, expansão material e direcionamento de vida, respeitando o tempo, o merecimento e os caminhos revelados em oráculo.",
      typesOverline: "Tipos Disponíveis",
      typesTitle: "TIPOS DE PACTOS E ACORDOS",
      cards: [
        {
          id: "prosperidade",
          title: "Pacto de Prosperidade Espiritual",
          text: "Acordo espiritual voltado para expansão financeira, abertura de oportunidades e fortalecimento do magnetismo material, conforme o caminho do consulente.",
          items: [],
        },
        {
          id: "baal",
          title: "Acordo Espiritual com o Grande Rei Baal",
          text: "Acordos direcionados a crescimento profissional, poder de decisão e liderança, expansão de caminhos materiais, organização e fortalecimento do destino profissional.",
          items: ["Crescimento profissional", "Poder de decisão e liderança", "Expansão de caminhos materiais", "Fortalecimento do destino profissional"],
        },
        {
          id: "belzebu",
          title: "Acordo Espiritual com o Rei Belzebu",
          text: "Acordos voltados para prosperidade contínua, remoção de obstáculos ocultos, fortalecimento pessoal e espiritual, estabilidade material e energética.",
          items: ["Prosperidade contínua", "Remoção de obstáculos ocultos", "Fortalecimento pessoal e espiritual", "Estabilidade material e energética"],
        },
        {
          id: "crescimento",
          title: "Acordos para Prosperar e Crescimento Profissional",
          text: "Trabalhos espirituais focados em evolução e reconhecimento na carreira, expansão de negócios, abertura de novas oportunidades profissionais e consolidação material ao longo do tempo.",
          items: ["Evolução e reconhecimento na carreira", "Expansão de negócios", "Abertura de novas oportunidades profissionais", "Consolidação material ao longo do tempo"],
        },
        {
          id: "ciclo",
          title: "Acordos Espirituais por Pedidos – Ciclo Anual",
          text: "Acordos espirituais estruturados para até três pedidos, definidos em consulta oracular, com atuação espiritual ao longo de um período de até um ano, visando a concretização dos objetivos buscados pelo consulente.",
          items: ["Planejamento espiritual de médio prazo", "Atuação progressiva e acompanhada", "Ajustes conforme os caminhos se abrem"],
        },
      ],
      important: {
        title: "Importante",
        items: [
          "Pactuações não são indicadas para todos os casos",
          "A aceitação depende de orientação oracular",
          "Exigem responsabilidade e consciência espiritual",
        ],
      },
      finalTitle: "AGENDAR CONSULTA ESPIRITUAL",
      finalText: "Toda pactuação inicia-se por consulta oracular para avaliação da indicação e alinhamento consciente.",
      cta: "Agendar Consulta",
      waMessage: "Olá, Mestre Jonas. Gostaria de agendar uma consulta sobre pactuações e acordos espirituais.",
    },
    internacional: {
      overline: "100% à Distância",
      title1: "ATENDIMENTO ESPIRITUAL",
      title2: "INTERNACIONAL",
      intro: "Os atendimentos são realizados 100% à distância, com o mesmo nível de seriedade e atuação energética de um atendimento presencial.",
      coverageOverline: "Cobertura Global",
      coverageTitle: "ATENDO EM TODO O MUNDO",
      regions: [
        { flag: "🇵🇹", id: "portugal", title: "Portugal", text: "Atendimento para clientes em todo Portugal." },
        { flag: "🇧🇷", id: "brasil", title: "Brasil", text: "Atendimento online para todo o território nacional." },
        { flag: "🌍", id: "global", title: "Outros países", text: "Atendimento online para clientes de qualquer parte do mundo." },
      ],
      coverageNote: "A distância física não limita a atuação espiritual. Os trabalhos são realizados com total eficácia independentemente da localização.",
      remoteOverline: "Como Funciona",
      remoteTitle: "ATENDIMENTO À DISTÂNCIA",
      remoteIntro: "O atendimento é feito de forma remota, mantendo toda a seriedade, sigilo e eficácia dos trabalhos espirituais. A energia não conhece fronteiras físicas.",
      remoteChecklist: [
        "Mesma seriedade e atuação energética",
        "Consultas via WhatsApp ou videoconferência",
        "Sigilo absoluto garantido",
        "Acompanhamento conforme o caso",
        "Horários flexíveis para diferentes fusos",
        "Comunicação em português",
      ],
      remoteCards: [
        { icon: "wifi", title: "100% Online", text: "Todas as consultas e trabalhos são realizados à distância, sem necessidade de deslocamento." },
        { icon: "pin", title: "Sem Fronteiras", text: "A atuação espiritual transcende barreiras físicas. Atendo clientes em qualquer parte do mundo." },
      ],
      finalTitle: "AGENDE SUA CONSULTA INTERNACIONAL",
      finalText: "Entre em contato pelo WhatsApp para agendar. Atendemos em seu horário local.",
      cta: "Falar no WhatsApp",
      waMessage: "Olá, Mestre Jonas. Gostaria de agendar uma consulta internacional.",
    },
    process: {
      overline: "O Caminho",
      title: "COMO FUNCIONA",
      steps: [
        { n: "01", title: "Entre em Contato", text: "Clique no WhatsApp e explique brevemente a situação que deseja tratar." },
        { n: "02", title: "Atendimento", text: "Mestre Jonas analisa a situação apresentada e orienta sobre a melhor forma de atendimento." },
        { n: "03", title: "Direcionamento", text: "Quando necessário, é indicado o trabalho espiritual ou ritual adequado ao caso." },
        { n: "04", title: "Acompanhamento", text: "O cliente recebe as orientações necessárias referentes ao atendimento realizado." },
      ],
    },
    depoimentos: {
      overline: "Consulentes",
      title: "O QUE DIZEM OS CONSULENTES",
      note: "Relatos de consulentes, com identidades preservadas.",
      items: [
        { text: "O atendimento foi conduzido com uma seriedade que eu nunca tinha encontrado. A consulta trouxe clareza para uma situação que me acompanhava há anos.", author: "Consulente — Brasil" },
        { text: "Discrição absoluta do primeiro contato ao acompanhamento. Senti respeito e direcionamento verdadeiro em cada etapa.", author: "Consulente — Portugal" },
        { text: "Mesmo à distância, o atendimento foi profundo e personalizado. Recebi orientações claras e um direcionamento espiritual sério.", author: "Consulente — Internacional" },
      ],
    },
    faq: {
      overline: "Dúvidas Frequentes",
      title: "PERGUNTAS FREQUENTES",
      items: [
        { q: "Como funciona a consulta espiritual?", a: "A consulta é um atendimento individualizado e online, realizado com horário previamente agendado. Através de consultas oraculares, a situação apresentada é analisada e você recebe um direcionamento espiritual para o seu caso." },
        { q: "O atendimento é realmente sigiloso?", a: "Sim. Todas as informações compartilhadas são tratadas de forma privada e confidencial. O respeito à privacidade de cada consulente é uma prioridade em todo o processo." },
        { q: "Vocês atendem fora do Brasil?", a: "Sim. O atendimento é 100% online e alcança clientes no Brasil, em Portugal e em outros países, com a mesma seriedade e discrição." },
        { q: "Como são indicados os trabalhos espirituais?", a: "Nenhum trabalho é indicado sem análise prévia. A indicação acontece durante a consulta, de forma individual, considerando a situação apresentada pelo consulente." },
        { q: "O que são pactuações?", a: "Pactuações são trabalhos de Alta Magia dentro de tradições de Goétia Luciferiana. São avaliadas individualmente e somente realizadas após análise e orientação durante o atendimento." },
        { q: "Os resultados são garantidos?", a: "Não prometemos nem garantimos resultados. Os atendimentos são práticas espirituais, rituais e direcionamentos personalizados, que respeitam o livre-arbítrio e a individualidade de cada pessoa." },
      ],
    },
    sigilo: {
      title: "SIGILO ABSOLUTO",
      paragraphs: [
        "Toda informação compartilhada durante o atendimento é tratada de forma privada e confidencial.",
        "O respeito à privacidade e à individualidade de cada consulente é uma prioridade durante todo o processo de atendimento.",
      ],
    },
    aviso: {
      overline: "Transparência",
      title: "AVISO LEGAL",
      paragraphs: [
        "Todos os atendimentos, consultas oraculares e trabalhos espirituais oferecidos por Mestre Jonas Barcellos são práticas de natureza espiritual e ritualística, realizados dentro de tradições de Alta Magia e Goétia Luciferiana.",
        "Nenhum resultado é prometido ou garantido. Cada situação é única, e os direcionamentos espirituais respeitam o livre-arbítrio e a individualidade de cada consulente.",
        "O atendimento é destinado exclusivamente a maiores de 18 anos e não substitui acompanhamento médico, psicológico, jurídico ou financeiro profissional.",
        "Todas as informações compartilhadas durante o atendimento são tratadas com sigilo absoluto.",
      ],
    },
    finalCta: {
      title1: "SE VOCÊ PROCURA ORIENTAÇÃO ESPIRITUAL,",
      title2: "FALE COM MESTRE JONAS",
      text: "Apresente sua situação de forma reservada e receba informações sobre a possibilidade de atendimento e direcionamento espiritual para o seu caso.",
      cta: "Falar no WhatsApp",
      note: "Atendimento com horário previamente agendado.",
    },
    footer: {
      tagline1: "Alta Magia • Goétia Luciferiana • Consultoria Espiritual",
      tagline2: "Brasil • Portugal • Atendimento Internacional",
      navTitle: "Navegação",
      contactTitle: "Contato",
      contactText: "Atendimento Brasil, Portugal e Internacional",
      rights: "© Mestre Jonas Barcellos — Todos os direitos reservados.",
      aviso: "Aviso Legal",
      contato: "Contato",
    },
    waDefault: "Olá, Mestre Jonas. Gostaria de informações sobre uma consulta ou trabalho espiritual.",
    goetia: {
      heroOverline: "Enciclopédia da Goétia Luciferiana",
      heroTitle: "ESPÍRITOS DA GOÉTIA",
      heroSubtitle: "Uma tradição de Alta Magia e ocultismo ocidental",
      intro: "Explore a tradição dos 72 espíritos descritos na Ars Goetia, primeira parte do Lemegeton, também conhecido como A Chave Menor de Salomão. Nesta enciclopédia estão reunidos os nomes, hierarquias, descrições tradicionais, atributos e sigilos associados a cada espírito.",
      noteLabel: "Nota histórica:",
      note: "as grafias dos nomes, hierarquias, descrições e correspondências podem variar entre manuscritos, traduções e escolas ocultistas. Esta página preserva essa diversidade e indica as diferenças relevantes.",
      searchPlaceholder: "Pesquisar espírito…",
      filterLabels: { todos: "Todos", reis: "Reis", duques: "Duques", principes: "Príncipes / Prelados", marqueses: "Marqueses", presidentes: "Presidentes", cavaleiros: "Cavaleiros", condes: "Condes / Earls" },
      resultsOne: "espírito encontrado",
      resultsMany: "espíritos encontrados",
      emptyTitle: "Nenhum espírito encontrado",
      emptyText: "Tente outro nome, número, hierarquia ou palavra-chave.",
      mapOverline: "Estrutura Tradicional",
      mapTitle: "HIERARQUIA DA GOÉTIA",
      mapCount: "Espíritos",
      rankSections: [
        { id: "reis", title: "Os Reis da Goétia", text: "Na tradição da Ars Goetia, os Reis ocupam o topo da hierarquia dos setenta e dois, sendo associados aos maiores poderes de comando, revelação e soberania." },
        { id: "duques", title: "Os Duques da Goétia", text: "Os Duques formam, segundo as fontes clássicas, o maior contingente da hierarquia, associados a conhecimentos, reconciliações, batalhas e favores." },
        { id: "principes", title: "Príncipes e Prelados", text: "Nas fontes clássicas, as designações de Príncipe e Prelado aparecem de forma próxima: traduções do Lemegeton e da Pseudomonarchia Daemonum empregam 'Prelado' para espíritos de alta dignidade principesca. Esta enciclopédia preserva a classificação da edição de Mathers e indica as divergências." },
        { id: "marqueses", title: "Os Marqueses da Goétia", text: "Os Marqueses são tradicionalmente associados ao ensino, à guerra, à construção e à revelação, ocupando posição intermediária na hierarquia." },
        { id: "presidentes", title: "Os Presidentes da Goétia", text: "Os Presidentes são ligados, na tradição, ao ensino das ciências e das artes, à proteção e à resposta verdadeira às questões do operador." },
        { id: "cavaleiros", title: "Os Cavaleiros da Goétia", text: "A Ars Goetia registra um único Cavaleiro: Furcas, mestre das artes divinatórias e filosóficas, singularidade preservada pelas fontes." },
        { id: "condes", title: "Os Condes da Goétia", text: "Os Condes — Earls nas fontes em inglês — são associados à guerra, à justiça, às tempestades e à restauração, muitas vezes acumulando dupla dignidade." },
      ],
      historyOverline: "Seção Histórica",
      historyTitle: "A TRADIÇÃO DA ARS GOETIA",
      historyBlocks: [
        { title: "O que é a Ars Goetia", p: ["A Ars Goetia é a primeira parte do Lemegeton Clavicula Salomonis, a Chave Menor de Salomão, um grimório compilado no século XVII a partir de materiais mais antigos, entre eles a Pseudomonarchia Daemonum, de Johann Weyer (1583).", "Na tradição, o texto descreve setenta e dois espíritos, suas hierarquias, aparências, atribuições e sigilos, dentro do sistema da magia cerimonial ocidental."] },
        { title: "Os 72 espíritos e a hierarquia", p: ["A lista organiza os espíritos em dignidades — Reis, Duques, Príncipes ou Prelados, Marqueses, Presidentes, um Cavaleiro e Condes — cada um associado a legiões e funções específicas.", "Essa classificação reflete estruturas cortesãs da época de compilação dos manuscritos, transpostas para o mundo espiritual."] },
        { title: "Os sigilos", p: ["Cada espírito é associado a um selo ou sigilo, traçado que, segundo a tradição, deve ser reproduzido e usado no contexto ritual descrito pelo grimório.", "Os sigilos apresentados nesta enciclopédia são reproduções dos selos históricos da edição de Mathers (1904), de domínio público."] },
        { title: "Diferenças entre manuscritos", p: ["Manuscritos do Lemegeton divergem em grafias, números de legiões e até em hierarquias. Weyer (1583) e a edição de Mathers (1904) apresentam diferenças documentadas, indicadas nas notas de cada espírito.", "Esta enciclopédia não trata a tradição como comprovação científica, mas como patrimônio histórico e simbólico do ocultismo ocidental."] },
      ],
      modernTitle: "GOÉTIA CLÁSSICA E INTERPRETAÇÕES MODERNAS",
      modernIntro: "A classificação das fontes clássicas pode ser reinterpretada por diferentes escolas modernas de ocultismo. Cada informação desta enciclopédia pertence a uma das três categorias abaixo.",
      modernCards: [
        { title: "Fonte Clássica", text: "Informações extraídas diretamente da Ars Goetia (ed. Mathers, 1904) e da Pseudomonarchia Daemonum (Weyer, 1583): nomes, hierarquias, legiões, aparências e atributos." },
        { title: "Interpretação Moderna", text: "Releituras produzidas por escolas ocultistas contemporâneas, sempre sinalizadas nos textos quando presentes — como associações atuais de prosperidade ou empoderamento." },
        { title: "Tradição Luciferiana Contemporânea", text: "Leituras próprias das correntes luciferianas atuais, que reinterpretam os espíritos como correntes de poder pessoal — identificadas como interpretação, nunca como registro histórico." },
      ],
      disclaimerTitle: "Aviso",
      disclaimerText: "Este conteúdo apresenta informações históricas, simbólicas e esotéricas relacionadas à tradição da Goétia. As descrições e atributos apresentados pertencem a tradições e fontes ocultistas e não constituem afirmações científicas sobre entidades sobrenaturais.",
      ctaTitle1: "APROFUNDE SEU ESTUDO DA",
      ctaTitle2: "ALTA MAGIA",
      ctaText: "Mestre Jonas Barcellos realiza consultas espirituais e atendimentos personalizados relacionados à Alta Magia, Goétia Luciferiana e práticas espirituais.",
      ctaBtn1: "Consulta Espiritual",
      ctaBtn2: "Falar com Mestre Jonas",
      ctaWa: "Olá, Mestre Jonas. Gostaria de informações sobre Alta Magia e Goétia Luciferiana.",
      legionsSuffix: "legiões, segundo a fonte clássica",
      viewProfile: "Ver Perfil Completo",
      compareSelected: "de 3 selecionados",
      compare: "Comparar",
      compareTitle: "Comparar Espíritos",
      thSpirit: "Espírito",
      thRank: "Hierarquia",
      thLegions: "Legiões",
      thAttributes: "Atributos Tradicionais",
      thSigil: "Sigilo",
      zoom: "Ampliar Sigilo",
      sigilCaption: "Sigilo tradicional — reprodução do selo histórico (domínio público)",
      backLink: "Enciclopédia da Goétia",
      altLabel: "Grafias alternativas:",
      prevLabel: "Anterior",
      nextLabel: "Próximo",
      consultAbout: "Consultar sobre",
      sourcesNote: "Descrições, aparências, hierarquias e legiões: fonte clássica (Ars Goetia / Weyer). Simbolismo: interpretação histórica contemporânea. Divergências entre fontes são indicadas nas notas.",
      profileSections: { description: "Descrição Tradicional", appearance: "Aparência Tradicional", attributes: "Atributos Tradicionais", symbolism: "Simbolismo", notes: "Notas", sources: "Fontes e Referências" },
    },
  },
  en: {
    navLinks: [
      ["Home", "inicio"],
      ["About", "quem-sou"],
      ["Spiritual Consultation", "consulta"],
      ["Spiritual Works", "trabalhos"],
      ["Pacts", "pactuacoes"],
      ["International", "internacional"],
      ["Notice", "aviso"],
      ["Contact", "contato"],
    ],
    navCta: "Chat on WhatsApp",
    hero: {
      overline: "High Magic • Luciferian Goetia • Spiritual Consultancy",
      title1: "MESTRE JONAS",
      title2: "BARCELLOS",
      tagline: "Serving clients in Brazil, Portugal and worldwide.",
      text: "Oracle consultations and personalized spiritual works, carried out with seriousness, discretion and absolute confidentiality.",
      cta1: "Speak with Mestre Jonas",
      cta2: "Discover the Works",
      note: "All works begin with a spiritual consultation.",
    },
    highlights: [
      { title: "Absolute Confidentiality", text: "Discreet and reserved service." },
      { title: "Personalized Service", text: "Every consultation and work is directed according to the situation presented by the client." },
      { title: "Brazil • Portugal • International", text: "Online service for clients in Brazil, Portugal and other countries." },
    ],
    marquee: ["Absolute Confidentiality", "High Magic", "Luciferian Goetia", "Spiritual Consultancy", "Tradition", "Discretion", "Brazil • Portugal • International"],
    about: {
      overline: "About",
      title: "WHO IS MESTRE JONAS BARCELLOS",
      paragraphs: [
        "Mestre Jonas Barcellos works in the field of High Magic, Luciferian Goetia and spiritual consultancy, offering oracle consultations and personalized spiritual works.",
        "His work is directed at people seeking spiritual guidance, understanding of personal situations and the practice of ritual work within a serious, reserved and individualized approach.",
        "Every session is carried out with discretion, respect for privacy and attention to the situation presented by the client.",
      ],
      cta: "Book a Consultation",
      waMessage: "Hello, Mestre Jonas. I would like to book a spiritual consultation.",
    },
    consulta: {
      overline: "Spiritual and Oracle Consultation",
      title1: "SPIRITUAL CONSULTATION THROUGH",
      title2: "ORACLES AND TAROT",
      intro1: "The Spiritual and Oracle Consultation is the first and most important step before any spiritual work. Through the Tarot and spiritual oracles, it is possible to access information about the past, the present and future trends, bringing clarity, guidance and safe direction.",
      intro2: "All consultations are carried out with seriousness, spiritual ethics, absolute confidentiality and deep interpretation, respecting the client's free will.",
      ctaHero: "Book a Spiritual Consultation",
      analysisOverline: "What Can Be Analyzed",
      analysisTitle: "IN THE ORACLE CONSULTATION",
      analysis: [
        {
          id: "passado",
          title: "Past",
          items: ["Spiritual situations influencing the present", "Old energetic blockages", "Spiritual bonds formed in the past", "Origin of recurring difficulties"],
        },
        {
          id: "presente",
          title: "Present",
          items: ["Current energetic and spiritual situation", "Paths open and closed at the moment", "Active spiritual influences", "People and energies around the client", "Possible spiritual interferences"],
        },
        {
          id: "futuro",
          title: "Future (Trends)",
          items: ["Future trends of the paths", "Possibilities of evolution or warning", "What may manifest if the current path continues", "What can be adjusted for better results"],
        },
      ],
      analysisNoteLabel: "Important:",
      analysisNote: "the oracle shows trends, not impositions. The future can be adjusted through conscious choices.",
      questionsOverline: "Types of Questions",
      questionsTitle: "THAT CAN BE ASKED IN THE CONSULTATION",
      questions: [
        {
          id: "financeira",
          title: "Financial Life and Prosperity",
          items: ["Are financial paths open?", "Are there spiritual blockages in prosperity?", "What is the best direction for material growth?", "Is any spiritual work indicated for prosperity?"],
        },
        {
          id: "profissional",
          title: "Work and Professional Life",
          items: ["Professional evolution", "Job or career change", "Recognition and growth", "Own businesses and opportunities", "Hidden obstacles in the professional environment"],
        },
        {
          id: "amor",
          title: "Love and Relationships",
          items: ["Energetic situation of the relationship", "Feelings involved", "Possibility of reconciliation", "Future affective paths", "External or spiritual influences on the relationship"],
        },
        {
          id: "espiritualidade",
          title: "Spirituality and Personal Energy",
          items: ["Current spiritual state", "Spiritual protection", "Presence of negative charges", "Need for spiritual cleansing", "Spiritual influences around you"],
        },
        {
          id: "ataques",
          title: "Attacks, Envy and Blockages",
          items: ["Is there envy or negative energy directed at you?", "Is there external spiritual interference?", "What is blocking your paths?", "Need for protection or energetic discharge"],
        },
        {
          id: "pactos",
          title: "Pacts, Agreements and Works",
          items: ["Whether performing spiritual works is indicated or not", "Which type of work is most suitable", "Whether pacts or spiritual agreements are advisable", "Which spiritual entity rules the client's path"],
        },
      ],
      howTitle: "HOW THE CONSULTATION WORKS",
      how: [
        { label: "Service", value: "Individual" },
        { label: "Format", value: "Remote (online)" },
        { label: "Interpretation", value: "Clear and detailed" },
        { label: "Confidentiality", value: "Total secrecy and respect" },
      ],
      warningTitle: "Important Notice",
      warning: "Spiritual and oracle consultations have an orientative and spiritual nature. They do not replace medical or psychological treatments, or legal decisions.",
      finalTitle: "BOOK YOUR SPIRITUAL CONSULTATION",
      finalText: "Get in touch via WhatsApp to book your consultation with absolute confidentiality and personalized service.",
      cta: "Book Spiritual Consultation via WhatsApp",
      waMessage: "Hello, Mestre Jonas. I would like to book a spiritual consultation.",
    },
    trabalhos: {
      overline: "Spiritual Works",
      title: "PERSONALIZED SPIRITUAL WORKS",
      intro: "Spiritual works and rituals personalized according to the needs presented by the client.",
      categories: [
        {
          id: "prosperity",
          title: "Prosperity and Finances",
          items: ["Opening of financial paths", "Prosperity rituals", "Abundance rituals", "Unblocking of paths", "Personalized works related to financial life"],
        },
        {
          id: "love",
          title: "Love and Relationships",
          items: ["Ritual for opening loving paths", "Love attraction ritual", "Love binding ritual", "Love sweetening ritual", "Couple reconciliation ritual", "Couple harmonization ritual", "Personalized works related to love"],
        },
        {
          id: "cleansing",
          title: "Cleansing and Unbinding",
          items: ["Deep spiritual cleansing", "Breaking of spiritual attacks", "Spiritual removal", "Unbinding of ties", "Energetic cuttings", "Spiritual cleansing works"],
        },
        {
          id: "protection",
          title: "Protection",
          items: ["Spiritual protection", "Luciferian protection", "Spiritual strengthening", "Spiritual defense works"],
        },
        {
          id: "power",
          title: "Personal Power",
          items: ["Empowerment ritual", "Beauty ritual", "Personal strengthening", "Works of spiritual development and strengthening"],
        },
        {
          id: "justice",
          title: "Justice, Truth and Revelation",
          items: ["Spiritual justice ritual", "Works related to justice", "Truth and revelation ritual", "Other personalized works"],
        },
      ],
      note: "The indication of each work is made individually, considering the situation presented during the session.",
      warning: {
        title: "Important Notice",
        items: [
          "All spiritual works are performed with responsibility and oracular guidance.",
          "Results vary according to the person, the moment and spiritual merit.",
          "They do not replace medical or psychological treatments, or legal decisions.",
        ],
      },
      cta: "Talk About My Case",
      waMessage: "Hello, Mestre Jonas. I would like to talk about my case.",
    },
    pactuacoes: {
      overline: "Conscious Agreements",
      title1: "PACTS AND SPIRITUAL",
      title2: "AGREEMENTS",
      intro1: "Pacts and spiritual agreements are carried out exclusively after a deep oracular consultation, with total clarity, spiritual responsibility and conscious alignment between the client and the indicated entity.",
      intro2: "These are works aimed at prosperity, professional growth, material expansion and life direction, respecting the timing, the merit and the paths revealed in the oracle.",
      typesOverline: "Available Types",
      typesTitle: "TYPES OF PACTS AND AGREEMENTS",
      cards: [
        {
          id: "prosperidade",
          title: "Spiritual Prosperity Pact",
          text: "Spiritual agreement aimed at financial expansion, opening of opportunities and strengthening of material magnetism, according to the client's path.",
          items: [],
        },
        {
          id: "baal",
          title: "Spiritual Agreement with the Great King Baal",
          text: "Agreements directed at professional growth, power of decision and leadership, expansion of material paths, organization and strengthening of professional destiny.",
          items: ["Professional growth", "Power of decision and leadership", "Expansion of material paths", "Strengthening of professional destiny"],
        },
        {
          id: "belzebu",
          title: "Spiritual Agreement with King Beelzebub",
          text: "Agreements aimed at continuous prosperity, removal of hidden obstacles, personal and spiritual strengthening, material and energetic stability.",
          items: ["Continuous prosperity", "Removal of hidden obstacles", "Personal and spiritual strengthening", "Material and energetic stability"],
        },
        {
          id: "crescimento",
          title: "Agreements for Prosperity and Professional Growth",
          text: "Spiritual works focused on career evolution and recognition, business expansion, opening of new professional opportunities and material consolidation over time.",
          items: ["Career evolution and recognition", "Business expansion", "Opening of new professional opportunities", "Material consolidation over time"],
        },
        {
          id: "ciclo",
          title: "Spiritual Agreements by Requests – Annual Cycle",
          text: "Spiritual agreements structured for up to three requests, defined in oracular consultation, with spiritual action over a period of up to one year, aiming at the fulfillment of the goals sought by the client.",
          items: ["Medium-term spiritual planning", "Progressive and monitored action", "Adjustments as paths open"],
        },
      ],
      important: {
        title: "Important",
        items: [
          "Pacts are not indicated for all cases",
          "Acceptance depends on oracular guidance",
          "They require spiritual responsibility and awareness",
        ],
      },
      finalTitle: "BOOK A SPIRITUAL CONSULTATION",
      finalText: "Every pact begins with an oracular consultation to assess the indication and conscious alignment.",
      cta: "Book Consultation",
      waMessage: "Hello, Mestre Jonas. I would like to book a consultation about pacts and spiritual agreements.",
    },
    internacional: {
      overline: "100% Remote",
      title1: "INTERNATIONAL SPIRITUAL",
      title2: "SERVICE",
      intro: "All sessions are held 100% remotely, with the same level of seriousness and energetic action as an in-person service.",
      coverageOverline: "Global Coverage",
      coverageTitle: "I SERVE CLIENTS WORLDWIDE",
      regions: [
        { flag: "🇵🇹", id: "portugal", title: "Portugal", text: "Service for clients across Portugal." },
        { flag: "🇧🇷", id: "brasil", title: "Brazil", text: "Online service throughout the national territory." },
        { flag: "🌍", id: "global", title: "Other countries", text: "Online service for clients anywhere in the world." },
      ],
      coverageNote: "Physical distance does not limit spiritual action. Works are performed with full effectiveness regardless of location.",
      remoteOverline: "How It Works",
      remoteTitle: "REMOTE SERVICE",
      remoteIntro: "The service is carried out remotely, maintaining all the seriousness, confidentiality and effectiveness of the spiritual works. Energy knows no physical borders.",
      remoteChecklist: [
        "Same seriousness and energetic action",
        "Consultations via WhatsApp or video call",
        "Absolute confidentiality guaranteed",
        "Follow-up according to each case",
        "Flexible hours for different time zones",
        "Communication in Portuguese and English",
      ],
      remoteCards: [
        { icon: "wifi", title: "100% Online", text: "All consultations and works are carried out remotely, with no need to travel." },
        { icon: "pin", title: "No Borders", text: "Spiritual action transcends physical barriers. I serve clients anywhere in the world." },
      ],
      finalTitle: "BOOK YOUR INTERNATIONAL CONSULTATION",
      finalText: "Get in touch via WhatsApp to book. We serve you in your local time.",
      cta: "Chat on WhatsApp",
      waMessage: "Hello, Mestre Jonas. I would like to book an international consultation.",
    },
    process: {
      overline: "The Path",
      title: "HOW IT WORKS",
      steps: [
        { n: "01", title: "Get in Touch", text: "Click the WhatsApp button and briefly explain the situation you wish to address." },
        { n: "02", title: "Session", text: "Mestre Jonas analyzes the situation presented and advises on the best form of service." },
        { n: "03", title: "Direction", text: "When necessary, the spiritual work or ritual suited to the case is indicated." },
        { n: "04", title: "Follow-up", text: "The client receives the necessary guidance regarding the work performed." },
      ],
    },
    depoimentos: {
      overline: "Clients",
      title: "WHAT CLIENTS SAY",
      note: "Client accounts, with identities preserved.",
      items: [
        { text: "The session was conducted with a seriousness I had never found before. The consultation brought clarity to a situation that had followed me for years.", author: "Client — Brazil" },
        { text: "Absolute discretion from the first contact to the follow-up. I felt respect and true guidance at every step.", author: "Client — Portugal" },
        { text: "Even at a distance, the session was deep and personalized. I received clear guidance and serious spiritual direction.", author: "Client — International" },
      ],
    },
    faq: {
      overline: "Common Questions",
      title: "FREQUENTLY ASKED QUESTIONS",
      items: [
        { q: "How does the spiritual consultation work?", a: "The consultation is an individualized online session, held at a previously scheduled time. Through oracle consultations, the situation presented is analyzed and you receive spiritual direction for your case." },
        { q: "Is the service truly confidential?", a: "Yes. All shared information is treated privately and confidentially. Respect for each client's privacy is a priority throughout the entire process." },
        { q: "Do you serve clients outside Brazil?", a: "Yes. The service is 100% online and reaches clients in Brazil, Portugal and other countries, with the same seriousness and discretion." },
        { q: "How are spiritual works indicated?", a: "No work is indicated without prior analysis. The indication happens during the consultation, individually, considering the situation presented by the client." },
        { q: "What are pacts?", a: "Pacts are High Magic works within Luciferian Goetia traditions. They are evaluated individually and only performed after analysis and guidance during the session." },
        { q: "Are results guaranteed?", a: "We do not promise or guarantee results. The sessions are spiritual practices, rituals and personalized guidance that respect each person's free will and individuality." },
      ],
    },
    sigilo: {
      title: "ABSOLUTE CONFIDENTIALITY",
      paragraphs: [
        "All information shared during the session is treated privately and confidentially.",
        "Respect for the privacy and individuality of each client is a priority throughout the entire service process.",
      ],
    },
    aviso: {
      overline: "Transparency",
      title: "LEGAL NOTICE",
      paragraphs: [
        "All sessions, oracle consultations and spiritual works offered by Mestre Jonas Barcellos are practices of a spiritual and ritualistic nature, carried out within High Magic and Luciferian Goetia traditions.",
        "No results are promised or guaranteed. Each situation is unique, and spiritual guidance respects the free will and individuality of each client.",
        "The service is intended exclusively for those over 18 years of age and does not replace professional medical, psychological, legal or financial care.",
        "All information shared during the session is treated with absolute confidentiality.",
      ],
    },
    finalCta: {
      title1: "IF YOU SEEK SPIRITUAL GUIDANCE,",
      title2: "SPEAK WITH MESTRE JONAS",
      text: "Present your situation privately and receive information about the possibility of service and spiritual direction for your case.",
      cta: "Chat on WhatsApp",
      note: "Service by previously scheduled appointment.",
    },
    footer: {
      tagline1: "High Magic • Luciferian Goetia • Spiritual Consultancy",
      tagline2: "Brazil • Portugal • International Service",
      navTitle: "Navigation",
      contactTitle: "Contact",
      contactText: "Serving Brazil, Portugal and International clients",
      rights: "© Mestre Jonas Barcellos — All rights reserved.",
      aviso: "Legal Notice",
      contato: "Contact",
    },
    waDefault: "Hello, Mestre Jonas. I would like information about a consultation or spiritual work.",
    goetia: {
      heroOverline: "Encyclopedia of Luciferian Goetia",
      heroTitle: "SPIRITS OF THE GOETIA",
      heroSubtitle: "A tradition of High Magic and Western occultism",
      intro: "Explore the tradition of the 72 spirits described in the Ars Goetia, the first part of the Lemegeton, also known as The Lesser Key of Solomon. This encyclopedia gathers the names, hierarchies, traditional descriptions, attributes and sigils associated with each spirit.",
      noteLabel: "Historical note:",
      note: "the spellings of names, hierarchies, descriptions and correspondences may vary between manuscripts, translations and occultist schools. This page preserves that diversity and indicates relevant differences.",
      searchPlaceholder: "Search spirit…",
      filterLabels: { todos: "All", reis: "Kings", duques: "Dukes", principes: "Princes / Prelates", marqueses: "Marquesses", presidentes: "Presidents", cavaleiros: "Knights", condes: "Earls" },
      resultsOne: "spirit found",
      resultsMany: "spirits found",
      emptyTitle: "No spirit found",
      emptyText: "Try another name, number, rank or keyword.",
      mapOverline: "Traditional Structure",
      mapTitle: "HIERARCHY OF THE GOETIA",
      mapCount: "Spirits",
      rankSections: [
        { id: "reis", title: "The Kings of the Goetia", text: "In the Ars Goetia tradition, the Kings occupy the top of the hierarchy of the seventy-two, being associated with the greatest powers of command, revelation and sovereignty." },
        { id: "duques", title: "The Dukes of the Goetia", text: "The Dukes form, according to the classical sources, the largest contingent of the hierarchy, associated with knowledge, reconciliations, battles and favors." },
        { id: "principes", title: "Princes and Prelates", text: "In the classical sources, the designations Prince and Prelate appear closely: translations of the Lemegeton and the Pseudomonarchia Daemonum use 'Prelate' for spirits of high princely dignity. This encyclopedia preserves the Mathers edition classification and indicates divergences." },
        { id: "marqueses", title: "The Marquesses of the Goetia", text: "The Marquesses are traditionally associated with teaching, war, construction and revelation, occupying an intermediate position in the hierarchy." },
        { id: "presidentes", title: "The Presidents of the Goetia", text: "The Presidents are linked, in the tradition, to the teaching of sciences and arts, to protection and to truthful answers to the operator's questions." },
        { id: "cavaleiros", title: "The Knights of the Goetia", text: "The Ars Goetia records a single Knight: Furcas, master of the divinatory and philosophical arts, a singularity preserved by the sources." },
        { id: "condes", title: "The Earls of the Goetia", text: "The Earls are associated with war, justice, storms and restitution, often accumulating double dignity." },
      ],
      historyOverline: "Historical Section",
      historyTitle: "THE TRADITION OF THE ARS GOETIA",
      historyBlocks: [
        { title: "What is the Ars Goetia", p: ["The Ars Goetia is the first part of the Lemegeton Clavicula Salomonis, The Lesser Key of Solomon, a grimoire compiled in the 17th century from older materials, among them Johann Weyer's Pseudomonarchia Daemonum (1583).", "In the tradition, the text describes seventy-two spirits, their hierarchies, appearances, attributions and sigils, within the system of Western ceremonial magic."] },
        { title: "The 72 spirits and the hierarchy", p: ["The list organizes the spirits into dignities — Kings, Dukes, Princes or Prelates, Marquesses, Presidents, one Knight and Earls — each associated with legions and specific functions.", "This classification mirrors courtly structures of the time of the manuscripts' compilation, transposed into the spiritual world."] },
        { title: "The sigils", p: ["Each spirit is associated with a seal or sigil, a tracing that, according to the tradition, must be reproduced and used in the ritual context described by the grimoire.", "The sigils presented in this encyclopedia are reproductions of the historical seals of the Mathers edition (1904), in the public domain."] },
        { title: "Differences between manuscripts", p: ["Lemegeton manuscripts diverge in spellings, legion numbers and even hierarchies. Weyer (1583) and the Mathers edition (1904) present documented differences, indicated in each spirit's notes.", "This encyclopedia does not treat the tradition as scientific proof, but as historical and symbolic heritage of Western occultism."] },
      ],
      modernTitle: "CLASSICAL GOETIA AND MODERN INTERPRETATIONS",
      modernIntro: "The classification of the classical sources may be reinterpreted by different modern schools of occultism. Every piece of information in this encyclopedia belongs to one of the three categories below.",
      modernCards: [
        { title: "Classical Source", text: "Information drawn directly from the Ars Goetia (Mathers ed., 1904) and the Pseudomonarchia Daemonum (Weyer, 1583): names, hierarchies, legions, appearances and attributes." },
        { title: "Modern Interpretation", text: "Rereadings produced by contemporary occultist schools, always flagged in the texts when present — such as current associations with prosperity or empowerment." },
        { title: "Contemporary Luciferian Tradition", text: "Readings proper to current Luciferian currents, which reinterpret the spirits as currents of personal power — identified as interpretation, never as historical record." },
      ],
      disclaimerTitle: "Notice",
      disclaimerText: "This content presents historical, symbolic and esoteric information related to the Goetia tradition. The descriptions and attributes presented belong to occultist traditions and sources and do not constitute scientific claims about supernatural entities.",
      ctaTitle1: "DEEPEN YOUR STUDY OF",
      ctaTitle2: "HIGH MAGIC",
      ctaText: "Mestre Jonas Barcellos holds spiritual consultations and personalized sessions related to High Magic, Luciferian Goetia and spiritual practices.",
      ctaBtn1: "Spiritual Consultation",
      ctaBtn2: "Speak with Mestre Jonas",
      ctaWa: "Hello, Mestre Jonas. I would like information about High Magic and Luciferian Goetia.",
      legionsSuffix: "legions, per the classical source",
      viewProfile: "View Full Profile",
      compareSelected: "of 3 selected",
      compare: "Compare",
      compareTitle: "Compare Spirits",
      thSpirit: "Spirit",
      thRank: "Rank",
      thLegions: "Legions",
      thAttributes: "Traditional Attributes",
      thSigil: "Sigil",
      zoom: "Enlarge Sigil",
      sigilCaption: "Traditional sigil — reproduction of the historical seal (public domain)",
      backLink: "Goetia Encyclopedia",
      altLabel: "Alternative spellings:",
      prevLabel: "Previous",
      nextLabel: "Next",
      consultAbout: "Ask about",
      sourcesNote: "Descriptions, appearances, hierarchies and legions: classical source (Ars Goetia / Weyer). Symbolism: contemporary historical interpretation. Divergences between sources are indicated in the notes.",
      profileSections: { description: "Traditional Description", appearance: "Traditional Appearance", attributes: "Traditional Attributes", symbolism: "Symbolism", notes: "Notes", sources: "Sources and References" },
    },
  },
};
